export default __webpack_public_path__ + "static/media/icons8-microsoft-powerpoint.1b89b992.svg";